import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-497b0cf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass({ 'my-pages-button': true, 'my-pages-button--active': _ctx.isActive })
  }, [
    _createElementVNode("a", {
      class: _normalizeClass({'icon': !!_ctx.icon && _ctx.isMobile, 'mobile-icon': _ctx.isMobile}),
      href: _ctx.url,
      style: _normalizeStyle(_ctx.isMobile && _ctx.icon ? { background: `url(${require('../assets/' + _ctx.icon)})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'contain' } : '')
    }, _toDisplayString(_ctx.text), 15, _hoisted_1)
  ], 2))
}